import { call, take, select, put } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { fetchProgramCall, getProgramCall, updateProgramCall, filterProgramCall } from '../../apis/wpApi/apiCalls'
import { OVERLAY_SPINNER } from '../../constants/overlayTypes'
import { overlaySetOverlayType, overlaySetRequestType, getProgramData, onSuccess, onError } from './helpers/request'
import { PROGRAM_UPDATE_DEFAULT } from '../../constants/state'
import authUser from '../../apis/wpApi/authUser'
import { OBJ_ELBENWALD_BRAND_MAPPINGS } from '../../constants/objectTypes'
import getMatchCandidates from '../../functions/getMatchCandidates'

const programDataSelector = state => state.getIn(['programData']).toJS()

function* setHasNoUpdates() {
    yield put({
        type: actionTypes.HAS_UPDATES_SET_FALSE,
        payload: {}
    })
}

function* getProgram(doFetch, signal =  false){
    const successType = yield doFetch ? actionTypes.PROGRAM_FETCH_SUCCESS : actionTypes.PROGRAM_GET_SUCCESS
    const errorType = yield doFetch ? actionTypes.PROGRAM_FETCH_ERROR : actionTypes.PROGRAM_GET_ERROR

    try {
        const apiKey = yield call(authUser.getToken)
        const apiCall = yield doFetch ? fetchProgramCall : getProgramCall
        const response = yield call(apiCall, apiKey, signal)
        const programData = yield call(getProgramData, response)

        yield call(setHasNoUpdates)
        yield call(onSuccess, successType, programData, doFetch)

        if (doFetch) {
            try {
                const previewMovieItems = yield select(state => state.getIn(['programData', 'pmPreviewMovies', 'items']))
                const movieMappingsItems = yield select(state => state.getIn(['programData', 'movieMappings', 'items']))
                const candidates = getMatchCandidates(
                    programData.fetchReport,
                    previewMovieItems ? previewMovieItems.toJS() : {},
                    movieMappingsItems ? movieMappingsItems.toJS() : {}
                )

                yield put({ type: actionTypes.PROGRAM_FETCH_MATCH_CANDIDATES_SET, candidates })
            } catch (matchCandidatesError) {
                yield call(console.log, 'error computing match candidates', matchCandidatesError)
                yield put({ type: actionTypes.PROGRAM_FETCH_MATCH_CANDIDATES_SET, candidates: [] })
            }
        }
    } catch(e){
        yield call(onError, errorType, e.message)

    }
}

function* publishAllDrafts(stateData) {
    const types = ["itemCollections", "itemSelectionsDisplay", "ads", "advertisements", "itemSelections", "highlights", "weischerAds"]
    types.forEach(
        type => {
            Object.keys(stateData[type].items).forEach(
                pk => {
                    let items = stateData[type].items
                    if(items[pk].draft){
                        items[pk].draft = false
                        stateData.updateProgram[type].update.push(pk)
                    }
                }
            )
        }
    )

    return stateData
}

function* getUpdateData(stateData) {
    const updateData = _.defaults({}, PROGRAM_UPDATE_DEFAULT)
    const updateProgram = stateData.updateProgram
    const keys = Object.keys(updateProgram).filter(u => u !== OBJ_ELBENWALD_BRAND_MAPPINGS)
    const keysLength = keys.length
    let i = 0

    for(i; i < keysLength; i++) {
        const key = keys[i]
        const data = updateProgram[key]
        const updateIdsLength = data.update.length
        let j = 0

        updateData[key].delete = data.delete

        for(j; j < updateIdsLength; j++) {
            const id = data.update[j]

            if(!data.hasOwnProperty('delete') || !data.delete.includes(id)) {
                const item = stateData[key].items[id]
                updateData[key].update.push(item)
            }
        }
    } 
    
    updateData[OBJ_ELBENWALD_BRAND_MAPPINGS] = stateData.updateProgram[OBJ_ELBENWALD_BRAND_MAPPINGS]

    return yield updateData
}

function* doUpdateCall()  {
    const apiKey = yield call(authUser.getToken)
    const programData = yield select(programDataSelector)
    const programDataModified = yield publishAllDrafts(programData)
    const updateData = yield getUpdateData(programDataModified)
    const response = yield call(updateProgramCall, apiKey, updateData)

    return yield response
}

function* doBeforeUpdate(beforeUpdate) {
    yield put({
        type: beforeUpdate.actionRequest,
        payload: beforeUpdate.actionPayload
    })

    const before = yield take([beforeUpdate.actionSuccess, beforeUpdate.actionError])

    if(beforeUpdate.actionError === before.type) {
        throw new Error(before.errorMessage)
    }
}

function* updateProgram(beforeUpdate) {
    try {
        if(false !== beforeUpdate) {
            yield call(doBeforeUpdate, beforeUpdate)
        }
        
        const response = yield call(doUpdateCall)
        
        yield call(setHasNoUpdates)
        yield call(onSuccess, actionTypes.PROGRAM_UPDATE_SUCCESS, yield getProgramData(response), true)

    } catch(e) {
        yield console.log('errror update', e) 
        yield call(onError, actionTypes.PROGRAM_UPDATE_ERROR, e.message)
    }
}

function* filterProgram() {
    try {
        // const programData = yield select(programDataSelector)
        // const updateData = yield getUpdateData(programData)
        // const responseUpdateData = yield call(updateProgramCall, apiKey, updateData)

        // yield call(onSuccess, actionTypes.PROGRAM_FILTER_SUCCESS, yield getProgramData(responseUpdateData), false)

        const apiKey = yield call(authUser.getToken)
        const response = yield call(filterProgramCall, apiKey)

        yield call(onSuccess, actionTypes.PROGRAM_FILTER_SUCCESS, yield getProgramData(response), true)
    } catch(e){
        yield call(onError, actionTypes.PROGRAM_FILTER_ERROR, e.message)
    }
}


function* watchProgramRequest() {
    try {
        while(true) {
            const request = yield take([actionTypes.PROGRAM_FETCH_REQUEST, actionTypes.PROGRAM_GET_REQUEST, actionTypes.PROGRAM_UPDATE_REQUEST, actionTypes.PROGRAM_FILTER_REQUEST])
            const requestType = yield request.type

            yield call(overlaySetRequestType, requestType)

            //ToDo: Race condition oder sowas was hier keinen interessiert ;) 
            if(actionTypes.PROGRAM_FETCH_REQUEST === requestType) {
                yield call(overlaySetOverlayType, OVERLAY_SPINNER)
                yield call(getProgram, true)
            }else if(actionTypes.PROGRAM_GET_REQUEST === requestType) {
                yield call(getProgram, false, request.payload.signal)
            } else if(actionTypes.PROGRAM_UPDATE_REQUEST === requestType) {
                yield call(overlaySetOverlayType, OVERLAY_SPINNER)
                yield call(updateProgram, request.payload.beforeUpdate)
            } else if(actionTypes.PROGRAM_FILTER_REQUEST === requestType) {
                yield call(overlaySetOverlayType, OVERLAY_SPINNER)
                yield call(filterProgram, false)
            }
        }

    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}


export default watchProgramRequest;